import {extraKeys} from "../etc";
import promisifyLoadImage from "../helpers/promisify-load-image";
import app from "../../app";
import {Looklab20240909Handler} from "@vicman-wi/processings-js-handlers/esm/handlers/looklab_20240909";
import md5 from "md5";
import {applyPostEffect} from "./shared/apply-post-effect";
import {defaultHandlerCatch, defaultHandlerResolver} from "./helpers";

/**
 * @param {Processing} processing
 * @param {Creative} creative
 * @param {object} options
 * @param {AbortSignal?} options.abortSignal
 */
export default async (processing, creative, options) => {
  return new Promise(async (resolve, reject) => {
    try {
      options = Object.assign({}, options);

      const creativeConfig = creative.getExtra(extraKeys.config);
      const targetSize = creative.getExtra(extraKeys.targetSize, [896, 1152]);
      const seed = creative.getExtra(extraKeys.seed);
      const userFile = processing.file;

      const handler = new Looklab20240909Handler(app.photolabApi, (data) => md5(data));
      const result = await handler.handle({
        file: {
          url: userFile.url,
          gender: processing.getExtra(extraKeys.gender),
          ageGroup: processing.getExtra(extraKeys.ageGroup),
          race: processing.getExtra(extraKeys.race),
          skinColor: processing.getExtra(extraKeys.skinColor),
          hairColor: processing.getExtra(extraKeys.hairColor2),
          hairStyle: processing.getExtra(extraKeys.hairStyle2),
        },
        photolabConfig: {
          id: creative.getExtra("config_id"),
          promptValuesTemplate: creativeConfig.extra.prompt_values_template,
          promptValuesKeys: creativeConfig.extra.prompt_values_keys,
        },
        seed: seed,
        resultWidth: targetSize[0],
        resultHeight: targetSize[1],
        checkUnsafeContent: !!creativeConfig.extra[extraKeys.isNsfw],
        checkFacesAmount: undefined, // отключено за ненадобностью
        roop: creativeConfig.extra[extraKeys.withRoop] !== false,
        cacheRead: true,
        cacheWrite: true,
        storePreview: true,
      }, {
        abortSignal: options.abortSignal,
      });

      creative.setExtra(extraKeys.handlerResult, result);

      if (result.unsafeContentResult) {
        creative.setExtra(extraKeys.unsafeContentResult, result);
      }

      if (result.error) {
        throw result.error;
      }

      let latestResultUrl = result.tasks.userRoop?.result?.resultUrl
        || result.promptResultUrl;

      const postEffectResult = await applyPostEffect(app.photolabApi, creativeConfig.extra["post_effects"], latestResultUrl);
      if (postEffectResult?.taskResult?.status === "OK") {
        latestResultUrl = postEffectResult.taskResult.resultUrl;
        creative.setExtra(extraKeys.postEffect, postEffectResult.effect);
      }

      creative.setFile("raw", latestResultUrl);

      options.abortSignal?.throwIfAborted();

      await promisifyLoadImage(latestResultUrl);
      creative.markAsProcessed(latestResultUrl);

      defaultHandlerResolver(creative, resolve)();
    } catch (err) {
      defaultHandlerCatch(creative, reject)(err);
    }
  });
}